import { properties } from "../properties";

export const fetchShowcaseManuscript = (key) =>
    fetch(properties.host + `/sample/showcase/${key}`).then(r => r.json());

export const fetchShowcaseTopSimilarPapers = (key) =>
    fetch(properties.host + `/sample/showcase/${key}/similar/top/papers`).then(r => r.json());

export const fetchShowcaseSimilarPapers = (key) =>
    fetch(properties.host + `/sample/showcase/${key}/similar/papers`).then(r => r.json());

export const fetchShowcaseDeepThinkers = (key) =>
    fetch(properties.host + `/sample/showcase/${key}/deepthinkers`).then(r => r.json());

export const fetchShowcaseAnalysis = (key) =>
    fetch(properties.host + `/sample/showcase/${key}/analysis`).then(r => r.json());

export function downloadShowcaseExport(key) {
    return new Promise((resolve, reject) => {
        const xhttp = new XMLHttpRequest();
        xhttp.open("GET", properties.host + `/sample/showcase/${key}/export/download`, true);
        xhttp.responseType = "blob";
        xhttp.onreadystatechange = function () {
            if (this.readyState === 4) {
                if (this.status === 200) {
                    resolve({ blob: xhttp.response, disposition: xhttp.getResponseHeader("Content-Disposition") });
                } else {
                    reject(new Error("Download failed"));
                }
            }
        };
        xhttp.send();
    });
}
